import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useLocalization } from '../contexts/LocalizationContext';
import DominoGenerator from './gen/DominoGenerator.tsx';
import PatternGenerator from './gen/PatternGenerator.tsx';
import PatternGeneratorText from './gen/PatternGeneratorText.tsx';
import CubeGenerator from './gen/CubeGenerator.tsx';
import RectangleDrawer from './gen/RectangleDrawer.tsx';
import KnightsGenerator from './gen/KnightsGenerator.js';
import ZebraGenerator from './gen/ZebraGenerator.js';
import DetectivePathGenerator from './gen/DetectivePathGenerator.js';
import DotSplitGenerator from './gen/DotSplitGenerator.js';
import DotSplitGenerator2 from './gen/DotSplitGenerator2.js';
import DijkstraGenerator from './gen/DijkstraGenerator.js';
import BucketGenerator from './gen/BucketGenerator.js';
import NumberStepsGenerator from './gen/NumberStepsGenerator.js';
import FewestTurnsGenerator from './gen/FewestTurnsGenerator.js';
import BFSGenerator from './gen/BFSGenerator.js';
import './GeneratorsScreen.css';

const GeneratorsScreen = () => {
  const { t } = useLocalization();
  const [activeGenerator, setActiveGenerator] = useState(null);
  const location = useLocation();

  const generators = [
    {
      id: 'domino',
      name: 'Dominoes',
      icon: '🎯',
      component: DominoGenerator
    },
    {
      id: 'pattern',
      name: 'Patterns',
      icon: '🔍',
      component: PatternGenerator
    },
    {
      id: 'pattern-text',
      name: 'Pattern Text',
      icon: '📝',
      component: PatternGeneratorText
    },
    {
      id: 'cubes',
      name: 'Cubes',
      icon: '🧊',
      component: CubeGenerator
    },
    {
      id: 'rectangles',
      name: 'Rectangles',
      icon: '📐',
      component: RectangleDrawer
    },
    {
      id: 'knights',
      name: 'Knights',
      icon: '⚔️',
      component: KnightsGenerator
    },
    {
      id: 'zebra',
      name: 'Zebra',
      icon: '🦓',
      component: ZebraGenerator
    },
    {
      id: 'detective-path',
      name: 'Detective Path',
      icon: '🕵️',
      component: DetectivePathGenerator
    },
    {
      id: 'garden-walk',
      name: 'Garden Walk',
      icon: '🌻',
      component: DotSplitGenerator
    },
    {
      id: 'dot-split',
      name: 'Dot Split',
      icon: '🔷',
      component: DotSplitGenerator2
    },
    {
      id: 'dijkstra',
      name: 'Dijkstra',
      icon: '🛤️',
      component: DijkstraGenerator
    },
    {
      id: 'bucket',
      name: 'Bucket',
      icon: '🪣',
      component: BucketGenerator
    },
    {
      id: 'number-steps',
      name: 'Number Steps',
      icon: '🔢',
      component: NumberStepsGenerator
    },
    {
      id: 'fewest-turns',
      name: 'Fewest Turns',
      icon: '🧭',
      component: FewestTurnsGenerator
    },
    {
      id: 'bfs',
      name: 'BFS Number Puzzle',
      icon: '🎯',
      component: BFSGenerator
    }
  ];

  if (activeGenerator) {
    const ActiveComponent = activeGenerator.component;
    return (
      <div className="generators-screen">
        <div className="generator-header">
          <button 
            onClick={() => setActiveGenerator(null)}
            className="back-button"
          >
            ← {t('generators.backToList', 'Back to Generators')}
          </button>
          <h1>{activeGenerator.name}</h1>
        </div>
        <ActiveComponent />
      </div>
    );
  }

  return (
    <div className="generators-screen">
      <div className="generators-header">
        <div className="header-content">
          <h1>{t('generators.title', 'Math Problem Generators')}</h1>
          <p className="subtitle">
            {t('generators.subtitle', 'Tools to create visual content for mathematical problems and exercises.')}
          </p>
        </div>
      </div>

      <div className="generators-grid">
        {generators.map(generator => (
          <div 
            key={generator.id} 
            className="generator-tile"
            onClick={() => setActiveGenerator(generator)}
          >
            <div className="generator-icon">{generator.icon}</div>
            <div className="generator-content">
              <h3 className="generator-name">{generator.name}</h3>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default GeneratorsScreen;
